import { useTranslation } from 'react-i18next';
import { SearchWarningNotice } from './SearchWarningNotice';

interface SearchDegradedNoticeProps {
  /**
   * Часть выдачи дал запасной поиск D1, потому что Postgres был недоступен
   * (сервер присылает `searchFallback: 'pg_unavailable'`, #932).
   */
  degraded: boolean;
  className?: string;
}

/**
 * Пометка «поиск в упрощённом режиме» (#1035).
 *
 * Без неё тот же запрос давал бы то 37 записей, то 0, то снова 37 — по тому,
 * ответил ли Postgres, — и это выглядело бы как потеря данных. Рядом с
 * выдачей, как соседки `SearchTruncatedNotice` и `SearchCappedNotice`.
 */
export function SearchDegradedNotice({
  degraded,
  className = '',
}: SearchDegradedNoticeProps) {
  const { t } = useTranslation('common');

  if (!degraded) return null;

  return (
    <SearchWarningNotice
      message={t('common.searchDegraded')}
      testId="search-degraded-notice"
      className={className}
    />
  );
}
